import { Checkbox, CheckboxProps } from 'antd';
import { clsx } from 'clsx';
import { FC } from 'react';

import s from './AntCheckbox.module.less';

export const AntCheckboxGroup = Checkbox.Group;

export const AntCheckbox: FC<CheckboxProps> = (props) => {
  const { className, ...rest } = props;

  return <Checkbox className={clsx(s.antCheckbox, className)} {...rest} />;
};

export type AntCheckboxProps = CheckboxProps;

AntCheckbox.displayName = 'AntCheckbox';
